export default () => {

  let osVersion;
  let os;
  let cookieEnabled;
// mobile version
  const nVer = navigator.appVersion;
  const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);
  let majorVersion;
  let version;
  let browser;
  let screenSize;
  {
    const unknown = '-';

    // screen
    screenSize = '';
    let width;
    let height;
    // eslint-disable-next-line no-restricted-globals
    if (screen.width) {
      // eslint-disable-next-line no-restricted-globals
      width = (screen.width) ? screen.width : '';
      // eslint-disable-next-line no-restricted-globals
      height = (screen.height) ? screen.height : '';
      screenSize += `${width} x ${height}`;
    }

    // browser
    const nAgt = navigator.userAgent;
    browser = navigator.appName;
    version = `${parseFloat(navigator.appVersion)}`;
    majorVersion = parseInt(navigator.appVersion, 10);
    let nameOffset;
    let verOffset;
    let ix;

    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
      browser = 'Opera';
      version = nAgt.substring(verOffset + 6);
      // eslint-disable-next-line no-cond-assign
      if ((verOffset = nAgt.indexOf('Version')) !== -1) {
        version = nAgt.substring(verOffset + 8);
      }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
      browser = 'Opera';
      version = nAgt.substring(verOffset + 4);
    }
      // Legacy Edge
    // eslint-disable-next-line no-cond-assign
    else if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
      browser = 'Microsoft Legacy Edge';
      version = nAgt.substring(verOffset + 5);
    }
      // Edge (Chromium)
    // eslint-disable-next-line no-cond-assign
    else if ((verOffset = nAgt.indexOf('Edg')) !== -1) {
      browser = 'Microsoft Edge';
      version = nAgt.substring(verOffset + 4);
    }
      // MSIE
    // eslint-disable-next-line no-cond-assign
    else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
      browser = 'Microsoft Internet Explorer';
      version = nAgt.substring(verOffset + 5);
    }
      // Chrome
    // eslint-disable-next-line no-cond-assign
    else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
      browser = 'Chrome';
      version = nAgt.substring(verOffset + 7);
    }
      // Safari
    // eslint-disable-next-line no-cond-assign
    else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
      browser = 'Safari';
      version = nAgt.substring(verOffset + 7);
      // eslint-disable-next-line no-cond-assign
      if ((verOffset = nAgt.indexOf('Version')) !== -1) {
        version = nAgt.substring(verOffset + 8);
      }
    }
      // Firefox
    // eslint-disable-next-line no-cond-assign
    else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
      browser = 'Firefox';
      version = nAgt.substring(verOffset + 8);
    }
    // MSIE 11+
    else if (nAgt.indexOf('Trident/') !== -1) {
      browser = 'Microsoft Internet Explorer';
      version = nAgt.substring(nAgt.indexOf('rv:') + 3);
    }
      // Other browsers
    // eslint-disable-next-line no-cond-assign
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
      browser = nAgt.substring(nameOffset, verOffset);
      version = nAgt.substring(verOffset + 1);
      if (browser.toLowerCase() === browser.toUpperCase()) {
        browser = navigator.appName;
      }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(';')) !== -1) version = version.substring(0, ix);
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(' ')) !== -1) version = version.substring(0, ix);
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(')')) !== -1) version = version.substring(0, ix);

    majorVersion = parseInt(`${version}`, 10);
    if (Number.isNaN(majorVersion)) {
      version = `${parseFloat(navigator.appVersion)}`;
      majorVersion = parseInt(navigator.appVersion, 10);
    }

    // cookie
    cookieEnabled = !!(navigator.cookieEnabled);

    if (typeof navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }

    // system
    os = unknown;
    const clientStrings = [
      { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
      { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
      { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
      { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
      { s: 'Windows Vista', r: /Windows NT 6.0/ },
      { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
      { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
      { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
      { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
      { s: 'Windows 98', r: /(Windows 98|Win98)/ },
      { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
      { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
      { s: 'Windows CE', r: /Windows CE/ },
      { s: 'Windows 3.11', r: /Win16/ },
      { s: 'Android', r: /Android/ },
      { s: 'Open BSD', r: /OpenBSD/ },
      { s: 'Sun OS', r: /SunOS/ },
      { s: 'Chrome OS', r: /CrOS/ },
      { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
      { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
      { s: 'Mac OS X', r: /Mac OS X/ },
      { s: 'Mac OS', r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
      { s: 'QNX', r: /QNX/ },
      { s: 'UNIX', r: /UNIX/ },
      { s: 'BeOS', r: /BeOS/ },
      { s: 'OS/2', r: /OS\/2/ },
      { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ },
    ];
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const id in clientStrings) {
      const cs = clientStrings[id];
      if (cs.r.test(nAgt)) {
        os = cs.s;
        break;
      }
    }

    osVersion = unknown;

    if (/Windows/.test(os)) {
      // eslint-disable-next-line prefer-destructuring
      osVersion = /Windows (.*)/.exec(os)[1];
      os = 'Windows';
    }

    // eslint-disable-next-line default-case
    switch (os) {
      case 'Mac OS':
      case 'Mac OS X':
      case 'Android':
        // eslint-disable-next-line prefer-destructuring
        osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([._\d]+)/.exec(nAgt)[1];
        break;

      case 'iOS':
        osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
        // eslint-disable-next-line no-bitwise
        osVersion = `${osVersion[1]}.${osVersion[2]}.${osVersion[3] | 0}`;
        break;
    }
  }

  return {
    browser,
    browserVersion: version,
    os,
    osVersion,
  };
}
